const WAYPOINTS_KEY = 'trailblaze_waypoints';
const TRACKS_KEY = 'trailblaze_tracks';

export function getLocalWaypoints() {
  try { return JSON.parse(localStorage.getItem(WAYPOINTS_KEY) || '[]'); }
  catch { return []; }
}

export function saveLocalWaypoint(data) {
  const list = getLocalWaypoints();
  const wp = { ...data, id: `local_${Date.now()}`, created_at: new Date().toISOString() };
  localStorage.setItem(WAYPOINTS_KEY, JSON.stringify([...list, wp]));
  return wp;
}

export function deleteLocalWaypoint(id) {
  localStorage.setItem(WAYPOINTS_KEY, JSON.stringify(getLocalWaypoints().filter(w => w.id !== id)));
}

export function getLocalTracks() {
  try { return JSON.parse(localStorage.getItem(TRACKS_KEY) || '[]'); }
  catch { return []; }
}

export function saveLocalTrack(data) {
  const list = getLocalTracks();
  const track = { ...data, id: `local_${Date.now()}`, created_at: new Date().toISOString() };
  localStorage.setItem(TRACKS_KEY, JSON.stringify([...list, track]));
  return track;
}

export function deleteLocalTrack(id) {
  localStorage.setItem(TRACKS_KEY, JSON.stringify(getLocalTracks().filter(t => t.id !== id)));
}

export function getLocalTrack(id) {
  return getLocalTracks().find(t => t.id === id) || null;
}
